import type { VoidFunctionComponent } from 'react';
import type { ReportGenerationParams } from '../../shared/types';
import { nuc } from '../../../../../utils';
import Sidebar from '../shared/components/Sidebar';

type Props = {
  params: ReportGenerationParams;
  resetFormat: () => void;
};

const ProjectLevelSidebar: VoidFunctionComponent<Props> = ({ params, resetFormat }: Props) => {
  const {
    revision_id: revisionId,
    project_id: projectId,
    report_type: reportType,
    reference,
    reference_type: referenceType,
  } = params;
  const baseUrl = `/projects/${nuc(projectId as string)}/refs/${referenceType}/${nuc(reference)}/${nuc(
    revisionId as string,
  )}/reports`;

  return <Sidebar url={baseUrl} reportType={reportType} resetFormat={resetFormat} />;
};

export default ProjectLevelSidebar;
